import { render, staticRenderFns } from "./DataPreview.vue?vue&type=template&id=21be2f9e&scoped=true&"
import script from "./DataPreview.vue?vue&type=script&lang=js&"
export * from "./DataPreview.vue?vue&type=script&lang=js&"
import style0 from "./DataPreview.vue?vue&type=style&index=0&id=21be2f9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21be2f9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
